module.exports = __webpack_public_path__ + "img/logoEU.4284029f.svg";